module.exports = __webpack_public_path__ + "img/loading-03.595b7d7c.svg";